export default __webpack_public_path__ + "static/media/bar-users.7b042359.svg";